export const delayTaskParameters = [
    {
      index: 1,
      delayChoice: "1 hora",
      no: 5,
      ed50: {
        immediate: 0.04167,
        delayed: 0.05893
      },
      k: {
        immediate: 24.0,
        delayed: 17.0
      }
    },
    {
      index: 2,
      delayChoice: "2 horas",
      no: 4,
      ed50: {
        immediate: null,
        delayed: null
      },
      k: {
        immediate: null,
        delayed: null
      }
    },
    {
      index: 3,
      delayChoice: "3 horas",
      no: 5,
      ed50: {
        immediate: 0.1021,
        delayed: 0.1444
      },
      k: {
        immediate: 9.79,
        delayed: 6.93
      }
    },
    {
      index: 4,
      delayChoice: "4 horas",
      no: 3,
      ed50: {
        immediate: null,
        delayed: null
      },
      k: {
        immediate: null,
        delayed: null
      }
    },
    {
      index: 5,
      delayChoice: "6 horas",
      no: 5,
      ed50: {
        immediate: 0.2041,
        delayed: 0.3062
      },
      k: {
        immediate: 4.90,
        delayed: 3.27
      }
    },
    {
      index: 6,
      delayChoice: "9 horas",
      no: 4,
      ed50: {
        immediate: null,
        delayed: null
      },
      k: {
        immediate: null,
        delayed: null
      }
    },
    {
      index: 7,
      delayChoice: "12 horas",
      no: 5,
      ed50: {
        immediate: 0.4330,
        delayed: 0.7071
      },
      k: {
        immediate: 2.31,
        delayed: 1.41
      }
    },
    {
      index: 8,
      delayChoice: "1 dia",
      no: 2,
      ed50: {
        immediate: null,
        delayed: null
      },
      k: {
        immediate: null,
        delayed: null
      }
    },
    {
      index: 9,
      delayChoice: "1.5 dias",
      no: 5,
      ed50: {
        immediate: 1.225,
        delayed: 1.732
      },
      k: {
        immediate: 0.816,
        delayed: 0.577
      }
    },
    {
      index: 10,
      delayChoice: "2 dias",
      no: 4,
      ed50: {
        immediate: null,
        delayed: null
      },
      k: {
        immediate: null,
        delayed: null
      }
    },
    {
      index: 11,
      delayChoice: "3 dias",
      no: 5,
      ed50: {
        immediate: 2.450,
        delayed: 3.464
      },
      k: {
        immediate: 0.408,
        delayed: 0.289
      }
    },
    {
      index: 12,
      delayChoice: "4 dias",
      no: 3,
      ed50: {
        immediate: null,
        delayed: null
      },
      k: {
        immediate: null,
        delayed: null
      }
    },
    {
      index: 13,
      delayChoice: "1 semana",
      no: 5,
      ed50: {
        immediate: 5.292,
        delayed: 8.573
      },
      k: {
        immediate: 0.189,
        delayed: 0.117
      }
    },
    {
      index: 14,
      delayChoice: "1.5 semanas",
      no: 4,
      ed50: {
        immediate: null,
        delayed: null
      },
      k: {
        immediate: null,
        delayed: null
      }
    },
    {
      index: 15,
      delayChoice: "2 semanas",
      no: 5,
      ed50: {
        immediate: 12.12,
        delayed: 17.15
      },
      k: {
        immediate: 0.0825,
        delayed: 0.0583
      }
    },
    {
      index: 16,
      delayChoice: "3 semanas",
      no: 1,
      ed50: {
        immediate: null,
        delayed: null
      },
      k: {
        immediate: null,
        delayed: null
      }
    },
    {
      index: 17,
      delayChoice: "1 mês",
      no: 5,
      ed50: {
        immediate: 25.28,
        delayed: 43.05
      },
      k: {
        immediate: 0.0396,
        delayed: 0.0232
      }
    },
    {
      index: 18,
      delayChoice: "2 meses",
      no: 4,
      ed50: {
        immediate: null,
        delayed: null
      },
      k: {
        immediate: null,
        delayed: null
      }
    },
    {
      index: 19,
      delayChoice: "3 meses",
      no: 5,
      ed50: {
        immediate: 74.56,
        delayed: 105.4
      },
      k: {
        immediate: 0.0134,
        delayed: 0.00949
      }
    },
    {
      index: 20,
      delayChoice: "4 meses",
      no: 3,
      ed50: {
        immediate: null,
        delayed: null
      },
      k: {
        immediate: null,
        delayed: null
      }
    },
    {
      index: 21,
      delayChoice: "6 meses",
      no: 5,
      ed50: {
        immediate: 149.1,
        delayed: 210.9
      },
      k: {
        immediate: 0.00671,
        delayed: 0.004741
      }
    },
    {
      index: 22,
      delayChoice: "8 meses",
      no: 4,
      ed50: {
        immediate: null,
        delayed: null
      },
      k: {
        immediate: null,
        delayed: null
      }
    },
    {
      index: 23,
      delayChoice: "1 ano",
      no: 5,
      ed50: {
        immediate: 298.2,
        delayed: 516.5
      },
      k: {
        immediate: 0.00335,
        delayed: 0.00194
      }
    },
    {
      index: 24,
      delayChoice: "2 anos",
      no: 2,
      ed50: {
        immediate: null,
        delayed: null
      },
      k: {
        immediate: null,
        delayed: null
      }
    },
    {
      index: 25,
      delayChoice: "3 anos",
      no: 5,
      ed50: {
        immediate: 894.7,
        delayed: 1265
      },
      k: {
        immediate: 0.00112,
        delayed: 0.000791
      }
    },
    {
      index: 26,
      delayChoice: "4 anos",
      no: 4,
      ed50: {
        immediate: null,
        delayed: null
      },
      k: {
        immediate: null,
        delayed: null
      }
    },
    {
      index: 27,
      delayChoice: "5 anos",
      no: 5,
      ed50: {
        immediate: 1633,
        delayed: 2310
      },
      k: {
        immediate: 0.000612,
        delayed: 0.000433
      }
    },
    {
      index: 28,
      delayChoice: "8 anos",
      no: 3,
      ed50: {
        immediate: null,
        delayed: null
      },
      k: {
        immediate: null,
        delayed: null
      }
    },
    {
      index: 29,
      delayChoice: "12 anos",
      no: 5,
      ed50: {
        immediate: 3579,
        delayed: 5368
      },
      k: {
        immediate: 0.000279,
        delayed: 0.000186
      }
    },
    {
      index: 30,
      delayChoice: "18 anos",
      no: 4,
      ed50: {
        immediate: null,
        delayed: null
      },
      k: {
        immediate: null,
        delayed: null
      }
    },
    {
      index: 31,
      delayChoice: "25 Anos",
      no: 5,
      ed50: {
        immediate: 7748,
        delayed: 9131
      },
      k: {
        immediate: 0.000129,
        delayed: 0.000110
      }
    }
  ];
